import { Collection } from 'backbone';
import { Player } from '../../models/core';

const HISTORY = {};

export class PlayersHistory extends Collection {
	initialize() {
		this.prefix = `nrl/archive/${(new Date()).getFullYear() - 1}`;
		this.url = '/players.json';
	}

	get model() {
		return Player;
	}

	updateYear(year) {
		this.prefix = `nrl/archive/${year}`;

		return this;
	}

	async requestData(year){
		return HISTORY[year] = HISTORY[year] || this.updateYear(year).fetch();
	}

	async getByYear(year){
		const result = await this.requestData(year);

		this.reset(result);

		return result;
	}
}

export default PlayersHistory;